import { Chart as ChartJS, Plugin } from 'chart.js'

import {
  FULFILMENT_TREND_LABEL_OFFSET,
  FULFILMENT_TREND_MAX_POINT_LABELS,
} from 'components/reports/Metrics/constants/DriverAppFulfilment'

export const formatRate = (value: number) => `${value.toFixed(1)}%`

const pointValueLabels: Plugin<'line'> = {
  id: 'pointValueLabels',
  afterDatasetsDraw(chart) {
    const { ctx } = chart
    const meta = chart.getDatasetMeta(0)
    const values = chart.data.datasets[0]?.data ?? []
    const last = values.length - 1
    const step = Math.max(1, Math.ceil(values.length / FULFILMENT_TREND_MAX_POINT_LABELS))

    ctx.save()
    ctx.textAlign = 'center'
    ctx.textBaseline = 'bottom'
    ctx.font = `600 11px ${ChartJS.defaults.font.family}`
    ctx.fillStyle = ChartJS.defaults.color as string

    meta.data.forEach((point, index) => {
      const value = values[index]

      if (typeof value !== 'number' || (last - index) % step !== 0) {
        return
      }

      ctx.fillText(formatRate(value), point.x, point.y - FULFILMENT_TREND_LABEL_OFFSET)
    })

    ctx.restore()
  },
}

export const fulfilmentTrendChartPlugins = [pointValueLabels]
